const creditScoreOptionItems = [
  {
    value: 549,
    label: 'Under 550',
  },
  {
    value: 550,
    label: '550-620',
  },
  {
    value: 621,
    label: '621-700',
  },
  {
    value: 701,
    label: 'Over 700',
  },
  {
    value: null,
    label: "I don't know",
  },
];

export default creditScoreOptionItems;
